export const ru = {
    'add-keywords': 'Добавить в ключевые фразы',
    remove: 'Удалить'
};
